import { t } from '@/features/i18n/utils';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { standardDeviationsQuery } from '@/features/standard-deviations/queries';
import { StandardDeviationsPage } from '@/features/standard-deviations/components/standard-deviations-page';
import { workspaceQuery } from '@/features/workspaces/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/',
)({
  staticData: { chatSurface: 'standard_deviation' },
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const workspace = await context.queryClient.query({
      ...workspaceQuery(params.workspaceId),
      staleTime: 'static',
    });
    return context.queryClient.query({
      ...standardDeviationsQuery(workspace.type, params.workspaceId),
      staleTime: 'static',
    });
  },
});

function RouteComponent() {
  const { workspaceId, projectId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbPage>
            {t({ en: 'Technical compliance', nb: 'Teknisk samsvar' })}
          </BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <StandardDeviationsPage />
    </>
  );
}
